import React from 'react';
import DepartmentTemplate from './DepartmentTemplate';

const DeptYonne89 = () => {
  return (
    <DepartmentTemplate
      department="Yonne"
      departmentNumber="89"
      cities="Auxerre, Sens, Joigny, Avallon"
      region="Bourgogne-Franche-Comté"
    />
  );
};

export default DeptYonne89;
